<template>
  <div v-show="value" class="dialog">
    <transition name="dialog-bounce">
      <div class="content" v-if="action_info">
        <div class="close" @click="close_modal">
        </div>
        <div class="head">
          {{action_info.union_pay_title}}
        </div>

        <div class="ruler" v-if="action_info.union_pay_ruler" v-html="action_info.union_pay_ruler">
        </div>


        <div class="info">
          <span class="highlight">芒果TV会员：</span>{{mgtv_nickname}}
        </div>
        <div class="info">
          <span class="highlight">{{action_info.union_vip_name}}：</span>{{cp_info.cp_nickname}}
        </div>
        <div class="info">
          会员产品包：{{action_info.product_name}}
        </div>

        <div class="price">
          <span class="real_price"><span style="font-size:.3rem;">￥</span>{{action_info.u_price}}</span>
          <span class="raw_price"><span style="font-size:.2rem;">￥</span>{{action_info.u_raw_price}}</span>
        </div>

        <div class="line"></div>


        <div class="channels">
          <div v-for="item in channels" class="channel" @click="choose_channel(item.channel)">
            <img :src="item.icon" alt="">
            <div>{{item.name}}</div>
          </div>
        </div>

      </div>
    </transition>


  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';

  export default create({
    name: 'UnionPayModal',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      action_info: Object
    },
    methods: {
      handleAction(action, data) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action, data);
      },
      close_modal() {
        this.handleAction('cancel', 'close_modal')
      },
      choose_channel(channel) {
        this.handleAction('confirm', {
          channel
        });
      },
    },
    computed: {
      mgtv_nickname() {
        return window.$bus.user.nickname
      },
      channels() {
        if (window.gact.is_ios_app) {
          return [{
              channel: 'apple',
              icon: 'https://vipcdn.mgtv.com/upload3/201812/1210/Apple.png',
              name: '苹果支付'
            }]
        } else if (window.gact.is_wx) {
          return [{
              icon: 'https://vipcdn.mgtv.com/upload3/201812/1210/wx.png',
              name: '微信支付',
              channel: 'wechat'
            }]
        } else if (window.gact.is_zfb) {
          return [{
              icon: 'https://vipcdn.mgtv.com/upload3/201812/1210/zfb.png',
              name: '支付宝',
              channel: 'alipay'
            }]
        } else {
          return [{
              icon: 'https://vipcdn.mgtv.com/upload3/201812/1210/wx.png',
              name: '微信支付',
              channel: 'wechat'
            },
            {
              icon: 'https://vipcdn.mgtv.com/upload3/201812/1210/zfb.png',
              name: '支付宝',
              channel: 'alipay'
            }]
        }
      }
    }

    });
</script>


<style lang="stylus" scoped>
  @import "../../../../share/mixins.styl"

  .dialog
    center()
    position fixed !important

  .close
    position absolute
    top -.6rem
    right -0.4rem
    width .5rem
    height @width
    background url(//vipcdn.mgtv.com/upload3/201902/12/close.png) no-repeat
    background-size cover

  .content
    position relative
    background white
    width 6.5rem
    border-radius: .1rem;
    padding-bottom .3rem;
    .head
      height: 1.1rem;
      border-radius: .1rem .1rem 0 0;
      background-image: linear-gradient(0deg, #fb4a37 0%, #fd7b1d 100%);
      line-height @height
      color white
      font-size .36rem
      text-align center
    .ruler
      width: 6rem;
      margin 0 auto
      word-break break-all
      padding .2rem 0
      font-size .28rem
      line-height: .3rem;
      div
        font-size .28rem
        color: #9e8882;
    .info
      width 6rem
      margin 0 auto
      line-height .45rem
      font-size .28rem
      .highlight
        color #fe8956
    .price
      display flex
      justify-content center
      margin .2rem auto .1rem
      align-items center
      color: #fb6409;
      .real_price
        font-size .54rem
        margin-right .08rem
      .raw_price
        font-size .3rem
        text-decoration line-through
    .line
      border-bottom 1px solid #9e8882
      width 6rem
      height 0
      margin 0 auto .2rem
    .channels
      position relative
      display flex
      flex-direction row
      justify-content center
      > .channel:nth-child(2)
        margin-left .8rem
      .channel
        display flex
        flex-direction column
        align-items center
        font-size .22rem
        div
          font-size .22rem
        img
          width .8rem
          margin .1rem

</style>



// WEBPACK FOOTER //
// src/components/Popups/UnionVip/PayModal/PayModal.vue